export default {"src":"/_next/static/media/popup.08591b3c.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};